@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="one" fxLayout="column">
  <div fxLayout="row wrap" class="pt-[12px]" fxLayoutAlign="end" fxFlex="1 0 auto">
    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      value="simple"
      (change)="onValChange($event.value)"
    >
      <mat-button-toggle value="simple">Simple</mat-button-toggle>
      <mat-button-toggle value="HTML">HTML</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <mat-label class="font-weight-700">Signature</mat-label>

  @if (signatureType != 'HTML') {
    <div fxLayout="row wrap" class="pt-[12px]" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <ckeditor
        [(ngModel)]="ckeditorValue"
        name="ckeditorValue"
        #ckeditor_full_desc
        [config]="configsOption"
        fxFlex="100"
        class="ckeClass ckeditor5_mode"
        [editor]="Editor"
        data=""
      ></ckeditor>
    </div>
  }

  @if (signatureType == 'HTML') {
    <div fxLayout="row wrap" class="pt-[12px]" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <!-- <mat-form-field appearance="outline" fxFlex="100">
        <textarea class="min_height_textarea" (focusout)="signaturePreview()" matInput [(ngModel)]="ckeditorValue"></textarea>
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="full-width pr-1" fxFlex="50">
        <mat-label>Notes</mat-label>

        <textarea
          matInput
          [(ngModel)]="ckeditorValue"
          (focusout)="signaturePreview()"
          rows="4"
          (keydown.enter)="$event.stopImmediatePropagation()"
        ></textarea>
      </mat-form-field>
    </div>
  }
  @if (signatureType == 'HTML') {
    <mat-label class="font-weight-700">Preview</mat-label>
  }

  @if (signatureType == 'HTML') {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <div fxFlex="100" class="parentHtmlCssDiv">
        <div [innerHTML]="htmlCss" class="previewDiv"></div>
      </div>
    </div>
  }
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      fxFlex="20"
      class="btn-add-2"
      [disabled]="isspiner"
      matButton="filled"
      (click)="updateSignatures()"
      cdkFocusInitial
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button fxFlex="20" class="pr-1 btn-add-2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
